import { UntypedFormControl } from '@angular/forms';

import { ICheckboxValueChanged, CheckboxData } from '../../models/checkboxes/checkbox-data.model';
import { FormField } from '../../models/form-builder/form-field.model';

// Define a class used to handle contacts-specified properties.
export class ContactsProperties implements ICheckboxValueChanged {
    // Properties.
    private readonly contactFields: string[] = ['Name', 'Email', 'Phone'];
    private contactFieldCheckboxData: CheckboxData[] = [];

    // Constructor.
    public constructor(formField: FormField) {
        let selectedFields: string[] = (formField.contactFieldNames != null ? formField.contactFieldNames.split('|') : []);

        for (let index: number = 0; index < this.contactFields.length; index++) {
            let contactFieldName: string = this.contactFields[index];

            let checkboxData: CheckboxData = new CheckboxData(index, this);
            checkboxData.title = contactFieldName;
            checkboxData.value = selectedFields.includes(contactFieldName.toLowerCase());
            checkboxData.setupFormControl();

            this.contactFieldCheckboxData.push(checkboxData);
        }
    }

    // Methods.
    public get ContactFieldNames(): string[] {
        return this.contactFields;
    }
    public getContactFieldNameFormControl(index: number): UntypedFormControl {
        let checkboxFormControl: UntypedFormControl = null;

        if ((this.contactFieldCheckboxData != null) && (index < this.contactFieldCheckboxData.length))
            checkboxFormControl = this.contactFieldCheckboxData[index].FormControl;

        return checkboxFormControl;
    }
    public isNotLastContactField(index: number): boolean {
        return (index < this.contactFields.length - 1);
    }
    public get CheckedFieldNames(): string[] {
        let checkedFieldNames: string[] = [];

        for (let index: number = 0; index < this.contactFieldCheckboxData.length; index++) {
            let checkboxData: CheckboxData = this.contactFieldCheckboxData[index];

            if (checkboxData.value == true)
                checkedFieldNames.push(checkboxData.title);
        }

        return checkedFieldNames;
    }
    public get DelimitedCheckedFieldNames(): string {
        let fieldNames: string = '';

        let checkedFieldNames: string[] = this.CheckedFieldNames;
        for (let index: number = 0; index < checkedFieldNames.length; index++) {
            if (index > 0)
                fieldNames += '|';
            fieldNames += checkedFieldNames[index].toLowerCase();
        }

        return fieldNames;
    }

    // Implement interface ICheckboxValueChanged.
    public checkboxValueChanged(index: number, checkboxData: CheckboxData): void {
        // Note:  this method is only being used to monitor checkbox data changes.
    }
}
